import { createContext, ReactNode, useContext } from 'react';

import {
  ThresholdMetadata,
  TooltipConfigData,
} from '../types/meter-bar-chart-internal.js';

export interface MeterBarChartInternalConfigContextProps {
  max: number;
  min: number;
  tooltip?: TooltipConfigData;
  label: ReactNode;
  thresholds: ThresholdMetadata;
  thresholdsIndicators: ThresholdMetadata;
}

export const MeterBarChartInternalConfigContext =
  createContext<MeterBarChartInternalConfigContextProps>(
    {} as MeterBarChartInternalConfigContextProps,
  );

export const useMeterBarChartInternalConfig = () =>
  useContext(MeterBarChartInternalConfigContext);
